module.exports = __webpack_public_path__ + "img/rock-big-18.da1b4586.png";